module.exports = __webpack_public_path__ + "img/Group 100.2b416650.svg";